/*
 * Hover-to-zoom for product images (desktop only).
 * On mouseenter over a product image, a magnified copy of the image fades in.
 * Moving the mouse over the image pans the zoomed view to follow the cursor,
 * giving a magnifying-glass effect. Mobile/touch devices keep the theme's
 * existing pinch-to-zoom dialog and are untouched by this script.
 */
(function () {
  var supportsHover =
    window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!supportsHover) return;

  var ZOOM_BACKGROUND_SIZE = '220%';

  function highResSrc(img) {
    return img.getAttribute('data_max_resolution') || img.currentSrc || img.src;
  }

  function setupZoom(img) {
    if (img.dataset.hzInit === 'true') return;
    if (img.closest('dialog')) return; // don't touch the existing click-to-zoom dialog
    img.dataset.hzInit = 'true';

    var container = img.closest('.product-media') || img.parentElement;
    if (!container) return;
    container.classList.add('hz-zoom-target');

    var pane = null;

    function onEnter() {
      pane = document.createElement('div');
      pane.className = 'hz-zoom-pane';
      pane.style.backgroundImage = 'url("' + highResSrc(img) + '")';
      pane.style.backgroundSize = ZOOM_BACKGROUND_SIZE;
      container.appendChild(pane);
      requestAnimationFrame(function () {
        if (pane) pane.classList.add('is-active');
      });
    }

    function onMove(event) {
      if (!pane) return;
      var rect = container.getBoundingClientRect();
      var x = ((event.clientX - rect.left) / rect.width) * 100;
      var y = ((event.clientY - rect.top) / rect.height) * 100;
      x = Math.max(0, Math.min(100, x));
      y = Math.max(0, Math.min(100, y));
      pane.style.backgroundPosition = x + '% ' + y + '%';
    }

    function onLeave() {
      if (pane) {
        pane.remove();
        pane = null;
      }
    }

    container.addEventListener('mouseenter', onEnter);
    container.addEventListener('mousemove', onMove);
    container.addEventListener('mouseleave', onLeave);
  }

  function initAll() {
    document.querySelectorAll('media-gallery img.product-media__image').forEach(setupZoom);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-scan when the gallery changes (variant swaps, theme editor updates, etc.).
  // setupZoom() guards against re-initializing images it has already wired up.
  var debounceTimer = null;
  var observer = new MutationObserver(function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(initAll, 150);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
